<div class="min-h-screen bg-gray-50 flex items-center justify-center">
    <div class="w-full max-w-xl px-4 sm:px-6 lg:px-8 py-8">
      <div class="text-center">
        <!-- Container principal -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          <!-- Icône d'erreur -->
          <div class="flex justify-center mb-6">
            <div class="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center">
              <span class="material-symbols-outlined text-4xl text-gray-400">error_outline</span>
            </div>
          </div>

          <!-- Titre -->
          <h1 class="text-6xl font-bold text-gray-900 mb-4">
            404
          </h1>
          
          <!-- Sous-titre -->
          <h2 class="text-2xl font-semibold text-gray-700 mb-4">
            Page inexistante
          </h2>
          
          <!-- Description -->
          <p class="text-base text-gray-500 mb-8 max-w-md mx-auto">
            La page que vous recherchez n'existe pas ou a été déplacée. 
            Veuillez vérifier l'URL ou retourner à la page d'accueil.
          </p>

          <!-- Boutons d'action -->
          <div class="flex flex-col sm:flex-row justify-center gap-3">
            <button 
              (click)="goHome()"
              class="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white text-base font-medium rounded-lg shadow-sm hover:shadow transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
              <span class="material-symbols-outlined text-xl">home</span>
              <span>Retour à l'accueil</span>
            </button>
            
            <button 
              (click)="goBack()"
              class="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white hover:bg-gray-50 text-gray-700 text-base font-medium rounded-lg border border-gray-300 shadow-sm hover:shadow transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
              <span class="material-symbols-outlined text-xl">arrow_back</span>
              <span>Retour</span>
            </button>
          </div>

          <!-- Suggestions supplémentaires -->
          <div class="mt-8 pt-6 border-t border-gray-200">
            <div class="flex flex-wrap justify-center gap-2 text-sm text-gray-500">
              <a routerLink="/dashboard" class="text-blue-600 hover:text-blue-700 hover:underline transition-colors">
                Tableau de bord
              </a>
              <span class="text-gray-300">•</span>
              <a routerLink="/suivi" class="text-blue-600 hover:text-blue-700 hover:underline transition-colors">
                Suivi
              </a>
              <span class="text-gray-300">•</span>
              <a routerLink="/ports" class="text-blue-600 hover:text-blue-700 hover:underline transition-colors">
                Machines
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
